import { Controller } from '@hotwired/stimulus'

const WEB_PROTOCOLS = ['http:', 'https:']

export default class extends Controller {
  static targets = ['frame']
  static values = {
    origins: { type: Array, default: [] },
    messageType: String,
    url: String
  }

  connect () {
    this.handleMessage = this.handleMessage.bind(this)
    window.addEventListener('message', this.handleMessage)
  }

  disconnect () {
    window.removeEventListener('message', this.handleMessage)
  }

  handleMessage (event) {
    if (!this.originsValue.includes(event.origin)) return
    if (!this.hasFrameTarget || event.source !== this.frameTarget.contentWindow) return
    if (event.data?.type !== this.messageTypeValue || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.href)
    if (!WEB_PROTOCOLS.includes(url.protocol)) return

    window.location.assign(url)
  }
}
